import React from 'react';
import PrimaryButtonSingleVoyage
    from "@containers/singleVoyage/ui/buttonts/primaryButtonSingleVoyage/PrimaryButtonSingleVoyage";
import {useTranslation} from 'react-i18next';
import {sx} from './sx'
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";


interface IProps {
    onClick?: () => void
}

const ToChangeCorrectionPointsModeBtnMutateSingleVoyage = ({onClick}: IProps) => {

    const {
        positions,
    } = useRootContextMutateSingleVoyage()

    const {setMode} = useViewContextMutateSingleVoyage()

    const {t} = useTranslation()

    const handleClickToPosition = () => {
        setMode('changeCorrectionPoints')
        onClick && onClick()
    }

    return (
        <PrimaryButtonSingleVoyage
            onClick={handleClickToPosition}
            disabled={!positions?.length}
            sx={sx.btn}
            variant={'secondary'}
            startIcon={<GpsFixedIcon/>}
        >
            {t('singleVoyage.changeAdjustingPoints')}
        </PrimaryButtonSingleVoyage>
    )
};

export default ToChangeCorrectionPointsModeBtnMutateSingleVoyage;